<script>
import baseEdit from '@/views/components/base/baseEdit.vue'
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: 'user',
      key: 'id',
      typeid:'',
      items: [
        {
          label: "",
          name: "",
          value: "",
          type: "kong",
          rules: [{ required: false, trigger: "blur" }],
        },
        { label: '基本信息', desc: '表单的基本信息', type: 'header' },
        { label: '账号', name: 'userName', value: '', type: 'input', rules: [{ required: true, trigger: 'blur' }] },
        { label: '密码', name: 'password', value: '', type: 'password', desc: "更新账户时，如不需要修改密码，请留空", },
        { label: '姓名', name: 'nickName', value: '', type: 'input', rules: [{ required: true, trigger: 'blur' }] },
        { label: '手机号', name: 'phonenumber', value: '', type: 'input', rules: [{ required: true, trigger: 'blur' }] },
        {
          label: '权限设置',
          name: 'makeMain',
          value: '',
          type: 'select',
          dropList: [
            { value: '1', name: '仅管理' },
            { value: '2', name: '仅维修' },
            { value: '3', name: '管理和维修' },
          ],
          onChange: this.onChangeMakeMain,
          rules: [{ required: true, trigger: 'blur' }]
        },
        {
          label: "员工类型",
          name: "mainType",
          value: "1",
          type: "select",
          dropList: [
            {
              value: 1,
              name: "维修员",
            },
            {
              value: 2,
              name: "派单员",
            },
          ],
          onChange: this.onMainType,
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        {
          label: "员工上级",
          name: "parentId",
          value: "",
          type: "select",
          dropList: [],
          rules: [{ required: true, trigger: "blur", type: "number"  }],
        },
        {
          label: "工作开始时间",
          name: "mainStartTime",
          value: "",
          type: "time",
          format: "HH:mm",
        },
        {
          label: "工作结束时间",
          name: "mainEndTime",
          value: "",
          type: "time",
          format: "HH:mm",
        },
        {
          label: "工单类型",
          name: "type",
          value: "",
          type: "multiple",
          dropList: [],
          onChange: this.onCouponAlis,
        },
        // { label: '登录密码', name: 'password', value: '', type: 'password', desc: '更新账户时，如不需要修改密码，请留空' },
        { label: '账号头像', name: 'avatar', value: '', type: 'image', desc: '建议图片宽高尺寸512*512像素及以上' },
        {
          label: '性别',
          name: 'sex',
          value: '',
          type: 'select',
          dropList: [
            { value: 1, name: '男' },
            { value: 2, name: '女' },
            { value: 0, name: '未知' },
          ],
        },
        {
          label: '角色',
          name: 'roleIds',
          value: '',
          type: 'multiple',
          dropList: [],
        },
        { label: '备注', name: 'remark', value: '', type: 'textarea' },
        { label: '状态', name: 'status', value: 0, type: 'switch', trueValue: 0, falseValue: 1},
      ],
      forms: {
        mainEndTime:'',
        mainStartTime:'',
        makeMain:'',
        mainType:1,
      },
    }
  },
  async created() {
    await this.loadtypeData();
    await this.loadMainData();
    let query = this.$route.query
    this.forms.status = 0
    if (query.action == 'edit') {
      await this.initData()
      this.onChangeMakeMain(this.forms.makeMain)
      this.onMainType(this.forms.mainType)
      this.items[this.getItemIndex('userName')].disabled = true
    }
    await this.shopStoreDropGroup()
    if (this.action === "add"){
      this.forms.makeMain = '1'
      this.onChangeMakeMain('1')
    }
  },
  methods: {
    onMainType(val) {
      if (val == 1 && this.forms.makeMain == '2') {
        this.items[this.getItemIndex("mainStartTime")].type = "time";
        this.items[this.getItemIndex("mainEndTime")].type = "time";
        this.items[this.getItemIndex("parentId")].type = "select";
      }
      if (val == 2) {
        this.items[this.getItemIndex("mainStartTime")].type = "kong";
        this.items[this.getItemIndex("mainEndTime")].type = "kong";
        this.items[this.getItemIndex("parentId")].type = "kong";
      }
    },
    onChangeMakeMain(val){
      if (val == '1'){
        this.items[this.getItemIndex('mainType')].type = 'kong'
        this.items[this.getItemIndex('parentId')].type = 'kong'
        this.items[this.getItemIndex('mainStartTime')].type = 'kong'
        this.items[this.getItemIndex('mainEndTime')].type = 'kong'
        this.items[this.getItemIndex('type')].type = 'kong'
        this.items[this.getItemIndex('type')].value = ''
        this.items[this.getItemIndex('roleIds')].type = 'multiple'
      }else if (val == '2'){
        this.items[this.getItemIndex('mainType')].disabled = false
        this.items[this.getItemIndex('mainType')].type = 'select'
        this.items[this.getItemIndex('parentId')].type = 'kong'
        this.items[this.getItemIndex('mainStartTime')].type = 'kong'
        this.items[this.getItemIndex('mainEndTime')].type = 'kong'
        this.items[this.getItemIndex('type')].type = 'multiple'
        this.items[this.getItemIndex('roleIds')].type = 'kong'
      } else if (val == '3'){
        this.forms.mainType = 2
        this.items[this.getItemIndex('mainType')].type = 'select'
        this.items[this.getItemIndex('mainType')].disabled = true
        this.items[this.getItemIndex('parentId')].type = 'kong'
        this.items[this.getItemIndex('mainStartTime')].type = 'kong'
        this.items[this.getItemIndex('mainEndTime')].type = 'kong'
        this.items[this.getItemIndex('type')].type = 'multiple'
        this.items[this.getItemIndex('roleIds')].type = 'multiple'
      }
    },
    onCouponAlis(val) {
      let ass = val.join(",");
      this.typeid = ass;
    },
    async loadtypeData() {
      // 通过pk查询字典数据
      let q = {};
      let res = await $utils.api.load("/admin/system/workType/fClass", q);
      if (res) {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "type") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                  this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      }
    },
    async loadMainData() {
      // 通过pk查询字典数据
      let q = {};
      let res = await $utils.api.load("/admin/system/maiUser/selectParentList", q);
      if (res) {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.userId;
            xx.name = element.nickName;
            xx.children = element.children || [];
            if(element.userId != this.kv){
            dropList.push(xx);
            }
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "parentId") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                  this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      }
    },
    async initData() {
      // 加载详情数据
      let id = this.kv
      let res = await $utils.api.load(`/admin/system/user/${id}`, {})
        try {
          this.forms = res.data
          if (res.data.type != ""){
            let typeArr = res.data.type.split(",")

            for (let i = 0; i <typeArr.length ; i++) {
              typeArr[i] = Number(typeArr[i])
            }
            this.forms.type = typeArr
          }

          let roleIdsArr = res.roleIds
          this.forms.roleIds = roleIdsArr
          console.log(555, this.forms.roleIds)
          this.forms.status = Number(res.data.status) || 0
          this.forms.sex = Number(res.data.sex) || 0
        }catch (e){
          console.log(e)
        }


    },
    async shopStoreDropGroup(shop_id = 0) {
      // 查询区域的分组下拉
      let q = {}
      let res = await $utils.api.load('/admin/system/role/optionselect', q)
      if (res) {
        if (res.data) {
          let dropList = res.data
          dropList.map((item) => {
            item.value = item.roleId
            item.name = item.roleName
          })
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index]
            if (element && element.name == 'roleIds') {
              // this.items[index]['dropList'] = dropList
              this.items[index]['dropList'] = (this.items[index]['dropList'] || []).concat(dropList)
            }
          }
        }
      }
    },
    handleSubmit() {
      console.log(444,this.forms.makeMain)
      if (!this.action) {
        return true
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.forms.group_ids = (this.forms.group_ids || []).join(',')
          this.forms.product_ids = (this.forms.product_ids || []).join(',')
          this.forms.shop_ids = (this.forms.shop_ids || []).join(',')
          this.forms.store_ids = (this.forms.store_ids || []).join(',')
          this.forms.type = this.typeid
          $form.handleSubmit(this)
        }
      })
    },
  },
}
</script>
